import { FC } from 'react';
import { useAppSelector } from '../../../hooks/store.hooks';
import InitMiddlewareAddUser from '../middlewares/InitMiddleware';
import AddProductProvider from '../memory/memr';

const AddProductInstance: FC<{}> = () => {
  return (
    <AddProductProvider>
      <InitMiddlewareAddUser />
    </AddProductProvider>
  );
};

export default AddProductInstance;
